<template>
  <v-row>
    <v-col cols="12" md="5">
      <v-row no-gutters>
        <v-col>
          <v-card outlined>
            <v-card-title>{{
              $capitalize($tc("model.leads_details_lead_button"))
            }}</v-card-title>
            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $capitalize($tc("model.leads_field_sinister_in")) }}
                    <b
                      >{{ lead.city && lead.city.name }},
                      {{ lead.country_area && lead.country_area.name }}</b
                    >
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-calendar</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $capitalize($tc("model.leads_field_sinister_occurred"))
                    }}
                    <b>{{ formatDate(lead.claim_date) }}</b>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-icon> </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $capitalize($tc("model.leads_field_participation_on")) }}
                    <b>{{ formatDate(lead.claim_involvement_date) }}</b>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-text</v-icon>
                </v-list-item-icon>
                <v-list-item-content
                  >{{ lead.claim_description }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-text>
              <v-btn block elevation="0" @click="lead_detail_modal = true">{{
                $capitalize($tc("model.leads_see_all_button"))
              }}</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card outlined>
            <v-card-title>
              {{ $capitalize($tc("model.leads_policy_detail")) }}
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                :to="{ name: 'lead_detail_policy' }"
                >{{ $capitalize($tc("model.leads_view_more_button")) }}</v-btn
              >
            </v-card-title>
            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-clock-start</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ $capitalize($tc("model.leads_field_beginning_in")) }}
                    <b>{{
                      formatDate(lead.policy.begin_date)
                    }}</b></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-clock-end</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ $capitalize($tc("model.leads_field_closes_in"))
                    }}<b>
                      {{ formatDate(lead.policy.end_date) }}</b
                    ></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card outlined>
            <v-card-title>{{
              $capitalize($tc("model.leads_title_participants"))
            }}</v-card-title>
            <v-list>
              <v-list-item
                v-for="participant in lead.participants"
                :key="participant.id"
              >
                <v-list-item-avatar>
                  <v-avatar
                    :color="participant.type == 'Segurado' ? 'primary' : '#ccc'"
                  >
                    <v-icon dark>mdi-account</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ participant.contact.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ participant.type }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-text>
              <v-btn block elevation="0" @click="openParticipantDialog">{{
                $capitalize($tc("model.leads_edit_participants_button"))
              }}</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <lead-management-list
            :lead_id="lead.id"
            :team="lead.team"
            :manager="lead.service_manager"
            :unity="lead.unity"
            @team_changed="handleChangeTeam"
            @manager_changed="handleChangeManager"
            @unity_changed="handleChangeUnity"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <v-row no-gutters>
        <v-col>
          <!-- TODO: 
          <v-card outlined>
            <v-card-title
              >Relatório de Visita <v-spacer></v-spacer>
              <v-btn text color="primary">Ver detalhes</v-btn></v-card-title
            >
            <v-card-text>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Et
              laudantium aspernatur vero inventore aliquid temporibus sint
              architecto maxime, maiores iste nesciunt excepturi nobis
              voluptate praesentium quo officiis, voluptates, magni earum?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-chip><v-icon small left>mdi-pencil</v-icon> Editar</v-chip>
              <v-chip class="ml-1"
                ><v-icon small left>mdi-adobe-acrobat</v-icon> Gerar
                PDF</v-chip 
              >
            </v-card-actions>
          </v-card>
          <v-card outlined>
            <v-card-title
              >Relatório Final <v-spacer></v-spacer>
              <v-btn text color="primary">Criar</v-btn></v-card-title
            >
          </v-card>
          <v-card outlined class="mt-5">
            <v-card-title
              >Relatório de Pesquisa <v-spacer></v-spacer>
              <v-btn text color="primary">Criar</v-btn></v-card-title
            >
          </v-card>
          <v-card outlined class="mt-5">
            <v-card-title
              >Relatório de Obras <v-spacer></v-spacer>
              <v-btn text color="primary">Criar</v-btn></v-card-title
            >
          </v-card>
          -->
          <div class="mb-3">
            <ContactAttempt />
          </div>
          <div>
            <LeadResume />
          </div>
        </v-col>
      </v-row>
    </v-col>

    <v-dialog v-model="participant_dialog" max-width="600px">
      <participants-detail @close="participant_dialog = false" />
    </v-dialog>

    <v-dialog v-model="lead_detail_modal" max-width="600px">
      <v-card>
        <v-card-title>
          {{ $capitalize($tc("model.leads_sinister_title")) }}
          <v-spacer></v-spacer>
          <v-btn icon @click="lead_detail_modal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-simple-table class="mx-2">
          <tbody>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_manager_title")) }}
              </td>
              <td>{{ lead.manager }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_external_status_lead")) }}
              </td>
              <td>
                <v-chip
                  class="ma-1"
                  v-for="service in lead.services"
                  :key="service.id"
                  >{{ service.state }}</v-chip
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_date_sinister_lead")) }}
              </td>
              <td class="text-left">{{ formatDate(lead.claim_date) }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_participation_date_lead")) }}
              </td>
              <td class="text-left">
                {{ formatDate(lead.claim_involvement_date) }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_taker_lead")) }}
              </td>
              <td class="text-left">
                <v-chip v-if="lead.participant_insured">{{
                  abreviate_participant_name(lead.participant_insured)
                }}</v-chip>
              </td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_description_lead")) }}
              </td>
              <td class="text-left">{{ lead.claim_description }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_regularization_type_lead")) }}
              </td>
              <td class="text-left">{{ lead.claim_regularizatioun_type }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_occurrence_type_lead")) }}
              </td>
              <td class="text-left">{{ lead.claim_occurrence_type }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_extras_lead")) }}
              </td>
              <td class="text-left">
                {{ lead.has_claim_extras ? "Sim" : "Nâo" }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_sinister_abroad_lead")) }}
              </td>
              <td class="text-left">
                {{ lead.is_claim_foreign ? "Sim" : "Nâo" }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_injured_people_lead")) }}
              </td>
              <td class="text-left">{{ lead.has_injured ? "Sim" : "Nâo" }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-card-title>{{
          $capitalize($tc("model.leads_leads_title"))
        }}</v-card-title>
        <v-simple-table class="mx-2">
          <tbody>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_creation_date_lead")) }}
              </td>
              <td class="text-left">{{ formatDate(lead.creation_date) }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_external_reference_lead")) }}
              </td>
              <td class="text-left">{{ lead.external_reference }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_product_type_lead")) }}
              </td>
              <td class="text-left">{{ lead.product_template_type }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_client_lead")) }}
              </td>
              <td class="text-left">{{ lead.insurer.name }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_services_lead")) }}
              </td>
              <td>
                <v-chip v-for="service in lead.services" :key="service.id">{{
                  service.service_number
                }}</v-chip>
              </td>
            </tr>
            <tr>
              <td class="font-weight-medium">
                {{ $capitalize($tc("model.leads_risk_location_lead")) }}
              </td>
              <td class="text-left">
                <span v-if="lead.morada">{{ lead.morada }}, </span>
                {{ lead.country_area.name }}, {{ lead.city.name }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import LeadResume from "@/components/Lead/LeadResume";
import ParticipantsDetail from "@/components/Lead/ParticipantsDetail";
import ContactAttempt from "@/components/Lead/ContactAttempt";
import { formatDate } from "@/tools/date";
import NameTool from "../../tools/names";
import LeadManagementList from "./LeadManagementList.vue";

export default {
  components: {
    LeadResume,
    ParticipantsDetail,
    ContactAttempt,
    LeadManagementList,
  },
  data: () => ({
    participant_dialog: false,
    lead_detail_modal: false,
  }),
  methods: {
    handleChangeTeam(team) {
      this.$store.commit("setLead", {
        ...this.lead,
        team,
        team_id: team.id,
      });
    },
    handleChangeManager(manager) {
      this.$store.commit("setLead", {
        ...this.lead,
        service_manager: manager,
        service_manager_id: manager.id,
      });
    },
    handleChangeUnity(unity) {
      this.$store.commit("setLead", {
        ...this.lead,
        unity,
        unity_id: unity.id,
      });
    },
    formatDate(date) {
      return formatDate(date);
    },
    openParticipantDialog() {
      this.participant_dialog = true;
    },
    abreviate_participant_name(participant) {
      if (participant && participant.contact)
        return NameTool.abreviate(participant.contact.name);
    },
  },
  computed: {
    lead: function () {
      return this.$store.getters.getLead;
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>